<template>
  <div class="c-survey__inner c-survey__bg--yellow">
    <div v-if="settings.prizeDrawEnabled" class="c-survey__bar c-survey__bg--blue">
      <div class="c-survey__bar-inner">
        <h1 class="white-text">{{ thankyou.preCode }} {{ submissionData.prizeDrawCode }}</h1>
      </div>
    </div>
    <div class="c-survey__content c-survey__content--padding c-survey__content--white-bg">
      <div class="c-survey__grid c-survey__grid--results">
        <div class="c-survey__results-wrapper">
          <main v-html="results.content" class="c-survey__html"></main>
          <div class="c-survey__grid c-survey__grid--results-choices">
            <div class="c-survey__results-total-wrapper">
              <div class="c-survey__results-total-circle">
                <h1>{{ resultsData.totalTokens }}</h1>
              </div>
              <h3>total tokens<br />spent</h3>
            </div>
            <div>
              <Pie :data="getChartDataChartOne.chartData" :options="getChartDataChartOne.chartOptions" />
            </div>
          </div>
          <main v-html="results.questionContent" class="c-survey__html"></main>
          <div class="c-survey__grid c-survey__grid--results-choices">
            <div class="c-survey__results-total-wrapper">
              <div class="c-survey__results-total-circle">
                <h1>{{ resultsData.totalResponses }}</h1>
              </div>
              <h3>total<br />responses</h3>
            </div>
            <div>
              <Pie :data="getChartDataChartTwo.chartData" :options="getChartDataChartTwo.chartOptions" />
            </div>
          </div>
        </div>
        <div class="c-survey__results-animation">
          <lottie-vue-player :src="results.animationFile" :player-controls="false" :loop="true" :autoplay="true"></lottie-vue-player>
        </div>
      </div>
      <div class="c-survey__actionbutton-row c-survey__actionbutton-row--right">
        <ActionButton :title="results.restartLabel" :buttonAction="'reset'"></ActionButton>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Chart as ChartJS, ArcElement } from "chart.js";
import { Pie } from "vue-chartjs";

// ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
ChartJS.register(ArcElement, ChartDataLabels);

export default {
  created() {},
  computed: {
    ...mapFields(["submissionData", "content.settings", "content.pages.thankyou", "content.pages.results", "resultsData"]),
    ...mapGetters(["getChartDataChartOne", "getChartDataChartTwo"]),
  },
  components: { ActionButton, Pie },
  mounted() {
    this.$store.dispatch("fetchSurveyData");
  },
  methods: {},
};
</script>
